import { notify } from '@/utils/notify';
import axios from 'axios';
import { attachTokenRefresh } from '@/utils/authInterceptors';

const baseURL = process.env.VUE_APP_ENV === 'production'
  ? "https://api.vibrant-wellness.com/v1/ehr/chat"
  : "https://api.vibrant-wellness.com/v1/ehr/chat-cloudstaging";

const internalNotesService = axios.create({
  baseURL: baseURL
});

internalNotesService.interceptors.request.use(
  async function(config) {
    // Get JWT token from session storage
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Set default headers
    config.headers['Content-Type'] = 'application/json';

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

internalNotesService.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('Internal Notes API Error:', error);

    // Error handling
    let message = 'An error occurred with internal notes';
    if (error.response) {
      message = error.response.data?.message || `Server Error: ${error.response.status}`;
    } else if (error.request) {
      message = 'Network error - please check your connection';
    }

    notify({
      title: "Error",
      message: message,
      type: "error",
      duration: 5000,
    });

    return Promise.reject(error);
  }
);

attachTokenRefresh(internalNotesService);

export default internalNotesService;
